import { useMemo } from 'react';
import { z } from 'zod/v4';

export const tableSearchParamsSchema = z.object({
  search: z.string().optional().catch(undefined),
  searchField: z.string().optional().catch(undefined),
});

export type TableSearchParams = z.infer<typeof tableSearchParamsSchema>;

export interface TableSearchSeedProps<TField extends string = string> {
  initialSearchValue: string | undefined;
  initialSearchField: TField | undefined;
}

export function useTableSearchParams<TField extends string = string>(params: TableSearchParams): TableSearchSeedProps<TField> {
  return useMemo(
    () => ({
      initialSearchValue: params.search,
      initialSearchField: params.searchField as TField | undefined,
    }),
    [params.search, params.searchField],
  );
}
